// extracted by mini-css-extract-plugin
export default {"lotStartPriceBlock":"styles_lotStartPriceBlock__tQ+Bb","lotStartPrice":"styles_lotStartPrice__f-U8H"};